module.exports = __webpack_public_path__ + "static/media/photo.c1d3d042.svg";